/*
 * @Author: zhengxiaowen
 * @Date: 2018-09-21 09:21:48
 * @Last Modified by: zhengxiaowen
 * @Last Modified time: 2018-12-21 09:27:01
 */
import jquery from 'jquery'
import store from '../store/StoreCommon'
import F2 from '@antv/f2'
import fetchDataCommon from '../config/fetchDataCommon'
import Vue from 'vue'

const service = {}

// 根据日期获取周信息
service.getWeek = function (date) {
  var a = new Array('日', '一', '二', '三', '四', '五', '六')
  var week = new Date().getDay()
  var str = '星期' + a[week]
  return str
}

// 更行键盘状态
service.updateKeyboardDid = function (type) {
  store.commit('UPDATE_KEYBOARD_DID', type)
}

// 计算屏幕内容高度，用于滚动组件
service.componentHeight = function () {
  return {
    native: store.state.system.isNative ? 0 : 46,
    tab: 44,
    h5SaafHeader:46
  }
}
service.getViewHeight = function (n) {
  //let height = jquery(document.body).height()
  let height = screen.height
  return height - n
}

// 翻页对象
service.pageServer = {
  newPage: function () {
    return {
      count: 0,
      counts: 0,
      curIndex: 0,
      firstIndex: 0,
      lastIndex: 0,
      nextIndex: 1,
      pageSize: 30,
      pagesCount: 0,
      preIndex: 0,
      lastFlag: true,
      firstLoader: true,
      loading: false
    }
  },
  update: function (oldPageObj, newPageObj) {
    let oldIndex
    for (oldIndex in oldPageObj) {
      if (newPageObj[oldIndex]) {
        oldPageObj[oldIndex] = newPageObj[oldIndex]
        if (oldIndex === 'nextIndex' && newPageObj[oldIndex] === 0) {
          oldPageObj.lastFlag = false
        }
      }
    }

      // 判断是否还有下一页
    if (oldPageObj.counts) {
      if (oldPageObj.curIndex === oldPageObj.pagesCount || oldPageObj.count <= oldPageObj.pageSize) {
        oldPageObj.lastFlag = false
      } else {
        oldPageObj.lastFlag = true
      }
    } else {
      if (oldPageObj.count) {
        if (oldPageObj.curIndex === oldPageObj.pagesCount || oldPageObj.count <= oldPageObj.pageSize) {
          oldPageObj.lastFlag = false
        } else {
          oldPageObj.lastFlag = true
        }
      }
    }

      // 更新第一次加载flag
    oldPageObj.firstLoader = false
    return oldPageObj
  }
}

// 根据年月生成 YYYY-MM 年月格式； 2018-09
service.createYearMonth = function (year, month) {
  return '' + year + '-' + (month >= 10 ? month : ('0' + month))
}

// yyyy-mm-dd 拆解成数组
service.dateSplit = function (dateStr) {
  let arr = dateStr.split('-')
  return arr
}

// 排班选项配置
service.schedulClasses = function () {
  return [{
    name: '早班', showName: '早', class: 'red', value: null, active: false, shiftType: 1
  }, {
    name: '晚班', showName: '晚', class: 'purple', value: null, active: false, shiftType: 2
  }, {
    name: '通班', showName: '通', class: 'blue', value: null, active: false, shiftType: 3
  }, {
    name: '休息', showName: '休', class: 'green', value: null, active: false, shiftType: 4
  }]
}

// 排班时间列表
service.schedulTimeList = function () {
  return [
    ['6:00', '6:30', '7:00', '7:30', '8:00', '8:30', '9:00', '9:30', '10:00', '10:30', '11:00', '11:30', '12:00', '12:30', '13:00', '13:30', '14:00', '14:30', '15:00', '15:30', '16:00', '16:30', '17:00', '17:30', '18:00', '18:30', '19:00', '19:30', '20:00', '20:30', '21:00', '21:30', '22:00'],
    ['6:00', '6:30', '7:00', '7:30', '8:00', '8:30', '9:00', '9:30', '10:00', '10:30', '11:00', '11:30', '12:00', '12:30', '13:00', '13:30', '14:00', '14:30', '15:00', '15:30', '16:00', '16:30', '17:00', '17:30', '18:00', '18:30', '19:00', '19:30', '20:00', '20:30', '21:00', '21:30', '22:00']
  ]
}

// 根据审批状态判断是否能编辑
service.verifyfFlowEdit = function (flowCode, fromFlag) {
  let flag = false
  if ((flowCode === 'DRAFT' || flowCode === 'REFUSAL') && fromFlag == 'Y') {
    flag = true
  } else if (flowCode === 'APPROVAL' || flowCode === 'ALLOW') {
    flag = false
  } else if (!flowCode && !fromFlag) {
    return true
  }
  return flag
}

// 格式化lookup
service.formatLookup = function (list) {
  let data = {}
  if (list && list.length) {
    list.forEach(item => {
      if (!data[item.lookupType]) {
        data[item.lookupType] = []
      }
      data[item.lookupType].push(item)
    })
  } else {
    alert('lookup传入类型错误')
  }
  return data
}

// 对比日期大小
service.compareDate = function (d1, d2, type) {
  switch (type) {
    case '==':
      return ((new Date(d1)) == (new Date(d2)))
      break
    case '>=':
      return ((new Date(d1)) >= (new Date(d2)))
      break
    case '<=':
      return ((new Date(d1)) <= (new Date(d2)))
      break
    case '>':
      return ((new Date(d1)) > (new Date(d2)))
      break
    case '<':
      return ((new Date(d1)) < (new Date(d2)))
      break
    default:
      alert('未有该类型判断式')
  }
}

service.getWindowWidth = function () {
  return window.innerWidth
}

service.getWindowHeight = function () {
  return window.innerHeight
}

// 计算长度生产高度
service.arrayCount = function (arr) {
  return 'height: ' + arr.length * 10 * 2 + 'px'
}

// 重置Canvas
service.resetCanvas = function (id) {
  var canvas = jquery('#' + id)  // 选择要擦除的canvas元素
  var context = canvas.get(0).getContext('2d')  // 获取canvas上下文

  context.clearRect(0, 0, canvas.width(), canvas.height())

  canvas.attr('width', canvas.width())
  canvas.attr('height', canvas.height())
}

// 生成条形图
service.F2CreatedDdge = function (config) {
  service.resetCanvas(config.id)
  var data = config.data
  var chart = new F2.Chart({
    id: config.id,
    pixelRatio: window.devicePixelRatio
  })

  chart.source(data.reverse(), {
    value: {
      tickInterval: config.maxValue
    }
  })
  chart.coord({
    transposed: true
  })

  chart.tooltip({
    custom: true, // 自定义 tooltip 内容框
    onChange: function onChange (obj) {
      var legend = chart.get('legendController').legends.top[0]
      var tooltipItems = obj.items
      var legendItems = legend.items
      var map = {}
      legendItems.map(function (item) {
        map[item.name] = _.clone(item)
      })
      tooltipItems.map(function (item) {
        var name = item.name
        var value = item.value
        if (map[name]) {
          map[name].value = value
        }
      })
      legend.setItems(_.values(map))
    },
    onHide: function onHide () {
      var legend = chart.get('legendController').legends.top[0]
      legend.setItems(chart.getLegendItems().country)
    }
  })
  chart.axis('label', {
    line: F2.Global._defaultAxis.line,
    grid: null
  })
  chart.axis('value', {
    line: null,
    grid: F2.Global._defaultAxis.grid,
    label: function label (text, index, total) {
      var textCfg = {}
      if (index === 0) {
        textCfg.textAlign = 'left'
      } else if (index === total - 1) {
        textCfg.textAlign = 'right'
      }
      return textCfg
    }
  })
  if(config.id=='POSReportBox'){
    chart.interval().position('label*value').color('type', [ '#68a3e9', '#ff7f0e']).adjust({
      type: 'dodge',
      marginRatio: 1 / 32
    })
  }else if(config.id=='MarketAnalyzeDetails'){
    chart.interval().position('label*value').color('type', [ '#68a3e9', '#ff7f0e','#2ca02c']).adjust({
      type: 'dodge',
      marginRatio: 1 / 32
    })
  }else{
    chart.interval().position('label*value').color('type').adjust({
      type: 'dodge',
      marginRatio: 1 / 32
    })
  }
  chart.render()
}

// 生成圆形
service.F2CreateCircle = function (config) {

  // config.value = 99999
  // config.maxValue = 10000000.11
  // config.htmlType = 2

  let unit = ''
  if(config.maxValue > 1000000){
    config.value = (config.value/1000000)
    config.maxValue = parseInt(config.maxValue/1000000)
    unit = '百万'
  }else if(config.maxValue > 10000){
    config.value = (config.value/10000)
    config.maxValue = parseInt(config.maxValue/10000)
    unit = '万'
  }

  let rValue = 100 * config.value / config.maxValue
  let rLineWidth = 7
  let rMaxValue = 100
  let time = new Date().getTime()
  let numberId = 'number' + time

  let rHtml = ''

  rHtml = `<div class="w80 text-center">
      ${config.html}
      <div><span id="${numberId}">0</span><span>/${config.maxValue}</span></div>
      <div class="c-666 f14">${unit}</div>
    </div>`

  if (config.htmlType == 2) {
    rHtml = `<div class="w80 text-center">
        ${config.html}
        <div><span id="${numberId}">0</span></div>
        <div class="c-666 f14">${unit}</div>
      </div>`
  }

  var Shape = F2.Shape
  var G = F2.G
  var Util = F2.Util
  var Global = F2.Global
  var Vector2 = G.Vector2

  Shape.registerShape('interval', 'tick', {
    draw: function draw (cfg, container) {
      var points = this.parsePoints(cfg.points)
      var style = Util.mix({
        stroke: config.borderColor ? config.borderColor : cfg.color
      }, Global.shape.interval, cfg.style)
      if (cfg.isInCircle) {
        var newPoints = points.slice(0)
        if (this._coord.transposed) {
          newPoints = [points[0], points[3], points[2], points[1]]
        }

        var _cfg$center = cfg.center,
          x = _cfg$center.x,
          y = _cfg$center.y

        var v = [1, 0]
        var v0 = [newPoints[0].x - x, newPoints[0].y - y]
        var v1 = [newPoints[1].x - x, newPoints[1].y - y]
        var v2 = [newPoints[2].x - x, newPoints[2].y - y]

        var startAngle = Vector2.angleTo(v, v1)
        var endAngle = Vector2.angleTo(v, v2)
        var r0 = Vector2.length(v0)
        var r = Vector2.length(v1)

        if (startAngle >= 1.5 * Math.PI) {
          startAngle = startAngle - 2 * Math.PI
        }

        if (endAngle >= 1.5 * Math.PI) {
          endAngle = endAngle - 2 * Math.PI
        }

        var lineWidth = r - r0
        var newRadius = r - lineWidth / 2

        return container.addShape('Arc', {
          className: 'interval',
          attrs: Util.mix({
            x: x,
            y: y,
            startAngle: startAngle,
            endAngle: endAngle,
            r: newRadius,
            lineWidth: lineWidth,
            lineCap: 'round'
          }, style)
        })
      }
    }
  })

  var data = [{
    x: '1',
    y: rValue
  }]
  var chart = new F2.Chart({
    id: config.id,
    pixelRatio: window.devicePixelRatio
  })
  chart.source(data, {
    y: {
      max: 100,
      min: 0
    }
  })
  chart.axis(false) // hide all axis
  chart.tooltip(false) // hide tooltip
  chart.coord('polar', {
    transposed: true,
    innerRadius: 0.8,
    radius: 0.85
  }) // set polar coordinate

  chart.guide().arc({
    start: [0, 0],
    end: [1, 99.98],
    top: false,
    style: {
      lineWidth: rLineWidth,
      stroke: '#ccc'
    }
  }) // draw a cricle
  chart.guide().html({
    position: ['50%', '50%'],
    html: rHtml
  }) // draw a text
  chart.interval().position('x*y').size(rLineWidth).shape('tick').animate({
    appear: {
      duration: 1200,
      easing: 'cubicIn',
      animation: function animation (shape, animateCfg) {
        var startAngle = shape.attr('startAngle')
        var endAngle = shape.attr('endAngle')
        shape.attr('endAngle', startAngle)
        shape.animate().to(Util.mix({
          attrs: {
            endAngle: endAngle
          }
        }, animateCfg)).onUpdate(function (frame) {
          if(unit){
            $('#' + numberId).text((parseInt(frame * config.value*100)/100).toFixed(2))
          }else{
            $('#' + numberId).text(parseInt(frame * config.value))
          }
        })
      }
    }
  })
  chart.render()
}

service.simplifyNumber = function (number) {
  return number
}

// oa流程催办 --- 只适用于育儿app
service.oaUrge = function(params){
  fetchDataCommon.bpmTaskService_findActiveTasks({params:params}).then(res=>{
    fetchDataCommon.bpmCommunicateService_save({params:{
      taskId: res.data[0].taskId,
      type: 'URGE',
      receiverId: res.data[0].processers[0].userId
    }}).then(urge=>{
      Vue.$vux.toast.show({
        type: 'success',
        text: urge.msg
      })
    })
  })
}

export default service



// WEBPACK FOOTER //
// ./src/common/tool/service.js